export const validation = {
  maxTitleChar: 120,
  maxParagraphChar: 1500,
  musicUrls: {
    min: 2,
    max: 12
  }
}
